<template>
  <OnboardingQuestion
    :title="question"
    :disabled="!answers.length"
    @next="handleClick"
  >
    <SelectOption v-model="answers" :icon="MusicNoteIcon" value="Music">
      Music
    </SelectOption>
    <SelectOption v-model="answers" :icon="CameraIcon" value="Photography">
      Photography
    </SelectOption>
    <SelectOption v-model="answers" :icon="PencilIcon" value="Writing">
      Writing
    </SelectOption>
    <SelectOption
      v-model="answers"
      :icon="PhotoIcon"
      value="Visual art / design"
    >
      Visual art / design
    </SelectOption>
    <SelectOption v-model="answers" :icon="VideoCameraIcon" value="Film / video">
      Film / video
    </SelectOption>
    <SelectOption v-model="answers" :icon="HelpIcon" value="Something else">
      Something else
    </SelectOption>
  </OnboardingQuestion>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  CameraIcon,
  HelpIcon,
  MusicNoteIcon,
  PencilIcon,
  PhotoIcon,
  VideoCameraIcon,
} from '@dacr/icons'

import OnboardingQuestion from '@/features/onboarding/components/OnboardingQuestion.vue'
import SelectOption from '@/shared/components/SelectOption.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { OnboardingStep, useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const question = 'What do you create?'

const answers = computed({
  get() {
    return (onboardingStore.state[OnboardingStep.Two] || []) as string[]
  },
  set(value: string[]) {
    onboardingStore.state[OnboardingStep.Two] = value
  },
})

const handleClick = () => {
  completeStep({ step: 2, question, answers: answers.value })

  onboardingStore.goToNextStep({ question, answers: answers.value })
}
</script>
